module.exports = __webpack_public_path__ + "img/0Q3A2940_L_Wood_MockedUp.f43d0853.jpg";